module.exports = __webpack_public_path__ + "img/carbon-radio-active.40777b5d.svg";